import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import {
  templateQuantity,
  templatePriority,
} from 'reducers/templates/selectors';
import { updatePriorityQuantity } from 'reducers/models/actions';
import { addProps } from 'utils/recompose';
import combineSelectors from 'utils/combineSelectors';
import { range } from 'lodash';

const mapStateToProps = combineSelectors({
  templateQuantity,
  templatePriority,
});

export const quantityOptions = ({ unsubmittedQuota }) => {
  return range(unsubmittedQuota + 1).map(quantity => ({
    clearable: false,
    value: quantity,
    label: quantity,
  }));
};

export const multiplePrioritiesSelected = ({ templatePriority }) =>
  templatePriority === 'Multiple';

export const onQuantityChange = ({
  templateId,
  priority,
  updatePriorityQuantity,
  templatePriority,
}) => event => {
  priority
    ? updatePriorityQuantity(templateId, priority, event.value)
    : updatePriorityQuantity(templateId, templatePriority, event.value);
};

export const displayQuantity = ({ quantity, templateQuantity, priority }) =>
  priority ? quantity : templateQuantity;

export default compose(
  connect(
    mapStateToProps,
    {
      updatePriorityQuantity,
    },
  ),
  addProps({ quantityOptions, multiplePrioritiesSelected, displayQuantity }),
  withHandlers({ onQuantityChange }),
);
